import { memo } from 'react';
import Typography from '@mui/material/Typography';

export default memo(Typography);
